var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centralized-issues-cycles-table-cell"},[_c('numeric-cycles',{staticClass:"centralized-issues-cycles-table-cell__cycles",attrs:{"data":Number(_vm.item.cycles)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }